import { HttpClient } from '../HttpClient'
/**
 * * Logout current logged user
 */
export const PostLogout = async () => {
  try {
    const { data } = await HttpClient.delete('api/users/LogOut')
    return await Promise.resolve(data)
  } catch (err) {
    return Promise.reject(err)
  }
}
